// extracted by mini-css-extract-plugin
module.exports = {"Heading":"IntegrationFeedNoResults_Heading__b563S","moreAppsButton":"IntegrationFeedNoResults_moreAppsButton__2sleL"};